import { render, staticRenderFns } from "./OrderPriceHead.vue?vue&type=template&id=473171ff&scoped=true"
import script from "./OrderPriceHead.vue?vue&type=script&lang=js"
export * from "./OrderPriceHead.vue?vue&type=script&lang=js"
import style0 from "./OrderPriceHead.vue?vue&type=style&index=0&id=473171ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473171ff",
  null
  
)

export default component.exports